import React, { useState } from 'react';
import './input.scss';

const Input = props => {
    const { label,
        value,
        name,
        errors,
        register,
        change,
        autoComplete,
        id,
        disabled = false,
        type = 'text',
        blurEvent,
        placeholder = ' ',
        icon,
        maxLength
    } = props;

    const [fieldActive, setfieldActive] = useState(false)
    const [textareaValue, settextareaValue] = useState('')

    const activateField = () => {
        setfieldActive(true)
    }

    const disableFocus = (e) => {
        if (e.target.value === "") {
            setfieldActive(false)
        }
    }

    return (
        <div className={"a-input-group " + (errors && errors[name] ? 'error ' : '')}>
            <label className={'a-input-label ' + (placeholder !== ' ' || (typeof value !== 'undefined' && value !== '') || fieldActive ? 'active ' : '') + (errors && errors[name] ? 'error ' : '') + (icon ? 'with-icon ' : '')}>{label}</label>
            {type === 'textarea' ?
                <textarea
                    className={"a-input a-textarea " + (placeholder !== ' ' || fieldActive ? 'active ' : '') + (errors && errors[name] ? 'error ' : '') + (disabled ? 'disabled ' : '') + (icon ? 'with-icon ' : '')}
                    id={id}
                    autoComplete={autoComplete ? "on" : "off"}
                    onChange={e => {
                        change && change(e)
                        settextareaValue(e.target.value)
                    }}
                    ref={register}
                    placeholder={placeholder}
                    name={name}
                    value={value}
                    type={type}
                    onBlur={e => { disableFocus(e); blurEvent && blurEvent() }}
                    onFocus={activateField}
                ></textarea>
                :
                <input
                    className={"a-input " + (placeholder !== ' ' || fieldActive ? 'active ' : '') + (errors && errors[name] ? 'error ' : '') + (disabled ? 'disabled ' : '') + (icon ? 'with-icon ' : '')}
                    id={id}
                    autoComplete={autoComplete ? "on" : "off"}
                    onChange={change}
                    ref={register}
                    placeholder={placeholder}
                    name={name}
                    value={value}
                    onKeyPress={e => {
                        if(e.key === '-') e.preventDefault()
                    }}
                    type={type}
                    onBlur={e => { disableFocus(e); blurEvent && blurEvent() }}
                    onFocus={activateField}
                />
            }
            {icon && <img
                src={icon}
                className="a-input-icon"
                alt='Ícono de input'
            />}
            {errors && errors[name] && <span className="a-input-error">{errors[name].message}</span>}
            {type === 'textarea' && maxLength && <div className="a-input-length-counter">
                {textareaValue.length} / {maxLength}
            </div>}
        </div>
    )
};

export default Input;